import $ from 'jquery';
import _ from 'underscore';
import Promise from 'bluebird';
import config from '@bingads-webui-component-legacy/config/index';
import { show as showPopup, dismiss } from '@bingads-webui-component-legacy/popup/view/index';
import { dismissHelpInfo, showHelpInfo, getTemplate } from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/budgetlandscape/popover/index';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import popupUtil from '@bingads-webui-static-legacy/popup';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import state from '@bingads-webui-component-legacy/state/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import { BudgetLandscapeView } from '@bingads-webui-campaign-legacy/budgetlandscape/view/budgetlandscape';
import { getBudgetRange } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import logger from '@bingads-webui-static-legacy/instrumentation/logger';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
// eslint-disable-next-line
import _bingads_webui_component_legacy_legacy_router_index from '@bingads-webui-component-legacy/legacy-router/index';
// eslint-disable-next-line
const { legacyRouter } = _bingads_webui_component_legacy_legacy_router_index;
import { formatLocaledSeasonalEventType } from '@bingads-webui-campaign/recommendation-core';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

const COMMENT_TYPES = {
  SUGGESTED: 'Suggested',
  CURRENT: 'Current',
  MAXVALUE: 'MaxValue',
  OTHER: 'Other',
};

function isSharedBudgetCampaign(entity) {
  const budget = _.result(entity, 'Budget');
  const budgetName = _.result(budget, 'Name');

  return !_.isEmpty(budgetName);
}

function isSharedBudgetRecommendation(budgetLandscapeView) {
  const options = _.result(budgetLandscapeView, 'options');
  const data = _.result(options, 'data');

  return _.result(data, 'IsShared');
}

function fetchBudgetLandscape(campaign) {
  let uri;
  const odataPath = config.get('adinsight.odata.url');

  if (isSharedBudgetCampaign(campaign)) {
    uri = `Customers(:customer_id)/Accounts(:account_id)/Recommendation.GetSharedBudgetLandscape(SharedBudgetId=${campaign.Budget.Id})`;
  } else {
    uri = `Customers(:customer_id)/Accounts(:account_id)/Campaigns(${campaign.Id})/Opportunity.GetBudgetLandscape`;
  }

  return odata.get(uri, {
    path: 'AdInsight/V2/',
    host: odataPath,
  });
}

let currentAlertId = null;

function dismissAlert() {
  if (currentAlertId) {
    window.App.views.alertCenter.dismiss(currentAlertId);
    currentAlertId = null;
  }
}

function showAlert(message) {
  dismissAlert();

  currentAlertId = window.App.views.alertCenter.show({
    message,
    level: 'Error',
    dismissible: true,
  }, currentAlertId);
}

// Process budget landscape data for rendering by recommention-inline-budget-view
/*
  1. check if the current budget is the suggested budget, if so, do not show the landscape
  2. change the indicator of current budget according to campaign current budget
*/
function processBudgetLandscapeResult(res, currentBudget) {
  const opportunityData = _.chain(res)
    .result('value').first()
    .value();

  if (!opportunityData || _.isEmpty(opportunityData)) {
    return {};
  } else {
    const landscapes = opportunityData.Landscapes;
    const maxBudgetInLandscape = _.max(_.map(landscapes, (landscape) => {
      return landscape.EstimatedBudget;
    }));
    const currentLargerThanMax = currentBudget >= maxBudgetInLandscape;

    const processedLandscapes = _.map(landscapes, (landscape) => {
      let { Comment } = landscape;
      const { EstimatedBudget } = landscape;
      const isCurrent = EstimatedBudget === currentBudget;

      if (Comment !== COMMENT_TYPES.MAXVALUE && Comment !== COMMENT_TYPES.SUGGESTED) {
        Comment = isCurrent ? COMMENT_TYPES.CURRENT : COMMENT_TYPES.OTHER;
      }
      return _.extend({}, landscape, { Comment });
    });

    return _.extend({ currentLargerThanMax }, opportunityData, { 'Landscapes': processedLandscapes });
  }
}

function getEventForecasting(res) {
  const opportunityData = _.chain(res)
    .result('value').first()
    .value();

  if (!opportunityData || _.isEmpty(opportunityData)) {
    return {
      eventName: '',
      isForecasting: false,
    };
  }
  return {
    eventName: opportunityData.SeasonalEvents.length > 0 ?
      formatLocaledSeasonalEventType(i18n, opportunityData.SeasonalEvents[0].Name) : '',
    isForecasting: opportunityData.IsForecasting,
  };
}

function onAction(event) {
  const action = event.currentTarget.attributes['data-action'].value;

  dismiss(action);
}

function onNoBudgetLandscapeForCampaignOutOfBudget(e, grid, isForVNext = false) {
  return showPopup(_.extend({},
    {
      positioningMethod: isForVNext ? 'fixed' : 'fit',
      positioningOptions: {
        positionAttribute: isForVNext ? 'fixed' : 'absolute',
        threshold: 0.5,
      },
      classes: ['popup--labels'],
      events: {
        'click .action': onAction,
      },
      template: () => i18n.getString('BudgetLandscape_NoBudget_InCampaignOutOfBudget'),
    },
    {
      container: grid.gridView.$el,
      anchor: $(e.target),
    }));
}

function p$updateBudget(update) {
  if (isSharedBudgetCampaign(update)) {
    return jsData.Budget.update(update.Budget.Id, _.pick(update.Budget, 'Amount'), { adapter: 'bulk', cacheResponse: false });
  } else {
    return jsData.Campaign.update(update.Id, update, { adapter: 'bulk', cacheResponse: false });
  }
}

function notifyAdInsight(id, budgetAmount, opportunityId) {
  const uri = 'Customers(:customer_id)/Accounts(:account_id)/Opportunity.Track',
    odataPath = config.get('adinsight.odata.url');
  const params = {
    'Request': {
      '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBulkOpportunitiesRequest',
      'CampaignAdGroups': [{
        Key: id,
        Value: [],
      }],
      'Channel': 'incontextrecommendation',
      'OpportunityType': 'BudgetOpportunity',
      'UserAction': 'Accept',
      'UserInputs': [{
        '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyBudgetOpportunityUserInputV2',
        'NewBudget': budgetAmount,
        'OpportunityId': opportunityId,
      }],
    },
  };

  return odata.post(uri, {
    path: 'AdInsight/V2/',
    host: odataPath,
    data: params,
  }).then(() => {
    logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'afterApplyBugetLandscape', 'Apply budget landscape success and notify ad insight finished');
  }).catch(() => {
    logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'afterApplyBugetLandscape', 'Apply budget landscape success but notify ad insight fail');
  });
}

function acceptBudgtLandscapeSuggestions(grid, campaign, newBudget, budgetLandscapeView, opportunityId) {
  // Convert localized value to float
  const budgetAmount = decimalNumber.fromLocalToFloat(newBudget);

  dismissAlert();

  p$updateBudget({
    Id: campaign.Id,
    Budget: _.defaults({ Amount: budgetAmount }, campaign.Budget),
  }).finally(withUiBlock(budgetLandscapeView.$el.closest('.popup-container')))
    .finally(() => {
      popupUtil.close();
    })
    .then((response) => {
      if (response.Errors) {
        return Promise.reject(response);
      } else {
        jsData.Campaign.findAll({
          limit: 1,
          select: ['DeliveryStatus', 'DeliveryStatusDetails'],
          where: { Id: { $eq: campaign.Id } },
        }).then((res) => {
          if (res.length && res.length > 0) {
            if (isSharedBudgetCampaign(campaign)) {
              dataContextManager.updateContext(['CampaignsGrid']);
              grid.gridView.refresh(true);
            } else {
              grid.gridView.trigger('didEdit', _.defaults({
                Budget: _.defaults({ Amount: budgetAmount }, campaign.Budget),
                DeliveryStatus: res[0].DeliveryStatus,
                DeliveryStatusDetail: res[0].DeliveryStatusDetail,
              }, campaign));
              grid.gridView.refresh(true);
            }
          } else {
            throw new Error('empty res from jsdata');
          }
        }).catch(() => {
          if (isSharedBudgetCampaign(campaign)) {
            dataContextManager.updateContext(['CampaignsGrid']);
            grid.gridView.refresh(true);
          } else {
            grid.gridView.trigger('didEdit', _.defaults({
              Budget: _.defaults({ Amount: budgetAmount }, campaign.Budget),
            }, campaign));
          }
        });

        if (!isSharedBudgetRecommendation(budgetLandscapeView)) {
          notifyAdInsight(campaign.Id, budgetAmount, opportunityId);
        }

        return Promise.resolve();
      }
    })
    .catch((response) => {
      if (response.Errors != null && response.Errors.length > 0 && response.Errors[0].Message != null) {
        showAlert(response.Errors[0].Message);
      } else {
        showAlert(i18n.getString('ErrorNumber_-1'));
      }
    });
}

function onFetchBudgetLandscapeSuccess(grid, campaign, data, event, isForVNext = false) {
  const parentItem = {
    CustomerId: state.get('customer_id'),
    AcctId: state.get('account_id'),
    CampaignName: campaign.Name,
    IsDailyBudgt: false,
  };

  if (campaign.Budget && campaign.Budget.Amount) {
    const budgetRange = getBudgetRange(config.get('AccountCurrencyCode'));

    parentItem.currentBudget = campaign.Budget.Amount;
    if (campaign.Budget.Type === 'Monthly') {
      parentItem.minBudget = budgetRange.Monthly.Min;
      parentItem.maxBudget = budgetRange.Monthly.Max;
    } else {
      parentItem.IsDailyBudgt = true;
      parentItem.minBudget = budgetRange.Daily.Min;
      parentItem.maxBudget = budgetRange.Daily.Max;
    }
  }
  const processedData = processBudgetLandscapeResult(data, parentItem.currentBudget);

  if ((!processedData || _.isEmpty(processedData)) && (campaign.DeliveryStatus === 'CampaignBudgetPaused')) {
    onNoBudgetLandscapeForCampaignOutOfBudget(event, grid, isForVNext);
    return;
  }

  const container = $('<div/>');

  let budgetLandscapeView = new BudgetLandscapeView({
    el: container[0],
    campaignOutOfBudget: campaign.DeliveryStatus && campaign.DeliveryStatus === 'CampaignBudgetPaused',
    parentItem,
    helpId: 'app51009',
    data: processedData,
    appConfig: config,
    legacyRouter,
    campaignId: campaign.Id,
    opportunityId: _.result(processedData, 'OpportunityId'),
    currentBudget: parentItem.currentBudget,
    isForVNext,
  });

  budgetLandscapeView.on('cancel', () => {
    popupUtil.close();
  });
  budgetLandscapeView.on('apply', ({ newBudget }) => {
    acceptBudgtLandscapeSuggestions(
      grid,
      campaign,
      newBudget,
      budgetLandscapeView,
      _.result(processedData, 'OpportunityId'),
    );
  });

  budgetLandscapeView.render();
  popupUtil.render(container);
}

/**
 * show budget landscape panel, and bind alll related actions including apply/cancel
 *
 * @param {Object} event - The backbone click event from where the quality score cell was clicked.
 * @param {Object} campaign - campaign entity that triggered this call, currently this status should only happen in campagin grid
 * @param {Object} grid - The grid where the call was triggered
 * @param {Boolean} isForVNext - Is new ui or not.
 * @returns {undefined}.
*/
export function openBudgetLandscapePanel(event, campaign, grid, isForVNext = false) {
  //close previous one, and stop other bindings
  popupUtil.close();
  event.stopPropagation();
  $('.budget-lanscape-popover-container').hide();

  fetchBudgetLandscape(campaign).then((res) => {
    onFetchBudgetLandscapeSuccess(grid, campaign, res, event, isForVNext);
  }).catch(() => {
    onNoBudgetLandscapeForCampaignOutOfBudget(event, grid, isForVNext);
  }).finally(withUiBlock($(event.target).parent()));
}

export function showBudgetLandscapeHelpInfo(event, campaign, grid, isForVNext = false) {
  const container = $('.budget-lanscape-popover-container');

  container.show();
  if (container.data('campaignId') !== campaign.Id || container.find('.budget-landscape-help-info-container').length === 0) {
    container.data('campaignId', campaign.Id);
    fetchBudgetLandscape(campaign).then((res) => {
      const { eventName, isForecasting } = getEventForecasting(res);

      showHelpInfo({
        event,
        targetEntity: campaign,
        i18n,
        eventName,
        isForecasting,
        showSuggestionClickedCallback: () => {
          openBudgetLandscapePanel(event, campaign, grid, isForVNext);
        },
      });
    }).catch(() => {
      showHelpInfo({
        event,
        targetEntity: campaign,
        i18n,
        eventName: '',
        isForecasting: false,
        showSuggestionClickedCallback: () => {
          openBudgetLandscapePanel(event, campaign, grid, isForVNext);
        },
      });
    });
  }
}

export function getBudgetLandscapeHelpInfoTemplate(campaign) {
  return fetchBudgetLandscape(campaign).then((res) => {
    const { eventName, isForecasting } = getEventForecasting(res);

    return getTemplate({
      targetEntity: campaign,
      i18n,
      eventName,
      isForecasting,
    });
  }).catch(() => {
    return getTemplate({
      targetEntity: campaign,
      i18n,
      eventName: '',
      isForecasting: false,
    });
  });
}

export function showBidLandscapeHelpInfo(event, campaign) {
  const container = $('.budget-lanscape-popover-container');

  if (container) {
    container.data('campaignId', null);
  }

  showHelpInfo({
    event,
    targetEntity: campaign,
    i18n,
    eventName: null,
    isForecasting: false,
    showSuggestionClickedCallback: _.noop,
  });
}

export function dismissBudgetLandscapeHelpInfo() {
  return dismissHelpInfo();
}
